
import { convertFromRaw, EditorState, ContentState } from 'draft-js';
export const ATUALIZAR_EDITOR = "editor/ATUALIZAR_EDITOR";
export const LIMPAR_EDITOR = "editor/LIMPAR_EDITOR";

export const iniciarEditor = (chave = "padrao", conteudo, somenteLeitura = false) => dispatch => {
  try {
    conteudo = convertFromRaw(JSON.parse(conteudo));
  } catch (erro) {
    conteudo = ContentState.createFromText(conteudo);
  }
  const editorState = EditorState.createWithContent(conteudo);

  if (somenteLeitura) {
    return editorState;
  }
  dispatch(quandoMudar(chave, editorState));
}

export const quandoMudar = (chave, editorState) => dispatch => {
  dispatch({ type: ATUALIZAR_EDITOR, ...{ chave, editorState } });
}

export const limparEditor = (chave = "padrao") => dispatch => dispatch({ type: LIMPAR_EDITOR, ...{ chave } });


// WEBPACK FOOTER //
// ./src/componentes/editor/actions.js